export default __webpack_public_path__ + "static/media/dc-motor.01917a37.png";